import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Badge } from 'reactstrap';

import * as actions from '../../../pages/laudo/etapas/material/material.action';

class MenuItem extends Component {
  render() {
    const menuClique = (props) => {
      props.actions.estadoMenuLateral(!this.collapsed);
      if (props.onClick) {
        props.onClick();
      }
      if (props.path) {
        props.history.push(props.path);
      }
    };
    return (
      <li
        onClick={
          () => {}
          // this.props.actions.estadoMenuLateral(!this.props.collapsed)
        }
      >
        {this.props.children ? (
          this.props.children
        ) : (
          <div onClick={() => menuClique(this.props)} className='button-menu with-icons'>
            <span className="menu-titulo">
            {this.props.icone &&
            <i className={this.props.icone}></i>
            }
            {this.props.title}{' '}
            {this.props.badge && Number(this.props.badge) !== 0 ? (
              <Badge color='info' pill >
                {this.props.badge}
              </Badge>
            ):''}</span>
          </div>
        )}
      </li>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    collapsed: state.recebimentoMaterial.collapsedMenu,
  };
};

const mapDispacthToProps = (dispatch) => {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
};

export default connect(mapStateToProps, mapDispacthToProps)(MenuItem);



// WEBPACK FOOTER //
// ./src/componentes/menu/menuItem/menuItem.component.js